export default "__VITE_ASSET__BW0m$9AQ__"